/**
 * Configuration Transloco pour vendeur.site.
 *
 * - Locales : fr (défaut), en, ar-TN
 * - Loader   : CodincloudTranslocoLoader (fetch backend /i18n/bundles)
 * - Missing  : CodincloudMissingHandler (rapport batch + IA via ACP)
 * - Misc     : pas d'inheritance entre langues (chaque bundle est complet).
 *
 * IMPORTANT — `provideTransloco()` retourne déjà des `EnvironmentProviders`.
 * On les étale dans `app.config.ts` via `...provideAppTransloco()`. Ne PAS
 * envelopper dans `makeEnvironmentProviders([...])` ni dans
 * `importProvidersFrom(TranslocoModule)` : ça casse l'injection.
 *
 * Note : `TranslocoService` ne doit PAS être injecté dans des services
 * `providedIn: 'root'` qui sont d'abord instanciés depuis un chunk LAZY.
 * Cela peut causer des duplications de `@jsverse/transloco` entre chunks
 * (la lib déclare `"sideEffects": false`) et donc 2 instances différentes
 * du token `TRANSLOCO_CONFIG` → `NullInjectorError`. Pour les composants/
 * services lazy, utiliser le pipe `transloco` ou le helper standalone
 * `translate()` qui passe par l'injecteur courant.
 */

import { EnvironmentProviders, Provider, isDevMode } from '@angular/core';
import {
  provideTransloco,
  provideTranslocoMissingHandler,
} from '@jsverse/transloco';

import { CodincloudTranslocoLoader } from './transloco-loader';
import { CodincloudMissingHandler } from './missing-handler';

export const SUPPORTED_LOCALES = ['fr', 'en', 'ar-TN'] as const;

export function provideAppTransloco(): Array<Provider | EnvironmentProviders> {
  return [
    ...provideTransloco({
      config: {
        availableLangs: SUPPORTED_LOCALES.map((code) => ({
          id: code,
          label: code,
        })),
        defaultLang: 'fr',
        fallbackLang: 'fr',
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
        missingHandler: {
          useFallbackTranslation: false,
          allowEmpty: false,
        },
      },
      loader: CodincloudTranslocoLoader,
    }),
    provideTranslocoMissingHandler(CodincloudMissingHandler),
  ];
}
